import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagFR(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-fr" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-fr)">
        <path fill="#000091" d="M0 0h7.5v24H0z" />
        <path fill="#fff" d="M7.5 0h9v24h-9z" />
        <path fill="#E1000F" d="M16.5 0H24v24h-7.5z" />
        <circle cx={12} cy={12} r={11.5} stroke="#3C3C60" strokeOpacity={0.1} />
      </g>
    </BaseIcon>
  );
}
